import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"brightness-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M4.57537 8.92462L1.5 12L4.57537 15.0754V19.4246H8.92462L12 22.5L15.0754 19.4246H19.4246V15.0754L22.5 12L19.4246 8.92462V4.57538H15.0754L12 1.5L8.92462 4.57538H4.57537V8.92462Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M10.4375 16.7509C11.4197 15.4224 12.0003 13.779 12.0003 12C12.0003 10.221 11.4197 8.57764 10.4375 7.24909C10.9292 7.08745 11.4545 7 12.0003 7C14.7618 7 17.0003 9.23858 17.0003 12C17.0003 14.7614 14.7618 17 12.0003 17C11.4545 17 10.9292 16.9126 10.4375 16.7509Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4.57537 8.92462L1.5 12L4.57537 15.0754V19.4246H8.92462L12 22.5L15.0754 19.4246H19.4246V15.0754L22.5 12L19.4246 8.92462V4.57538H15.0754L12 1.5L8.92462 4.57538H4.57537V8.92462Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M10.4375 16.7509C11.4197 15.4224 12.0003 13.779 12.0003 12C12.0003 10.221 11.4197 8.57764 10.4375 7.24909C10.9292 7.08745 11.4545 7 12.0003 7C14.7618 7 17.0003 9.23858 17.0003 12C17.0003 14.7614 14.7618 17 12.0003 17C11.4545 17 10.9292 16.9126 10.4375 16.7509Z","strokeWidth":"props.strokeWidth"}}]}]};

const Brightness1 = Vue.extend<IconProps>({
  name: 'Brightness1Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'brightness-1',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Brightness1;
